import EditAssessment from './EditAssessment';

export default EditAssessment;
